import { FormRichTextEditor, FormSectionHeader, FormSelect, Heading, Loader } from "@/components";
import useAddEdit from "./useAddEdit";
import { FormProvider } from "react-hook-form";
import { CONTENT, STATE } from "./consts";
import { Button } from "@/components/ui";
import { stateLawStatus } from "@/lib/utils";

const AddEdit = () => {
  const {
    breadcrumbData,
    onBackClick,
    form,
    onSubmit,
    requiredFields,
    isAddPending,
    onCancel,
    stateList,
    isStateLoading,
    isStateLawDataLoading,
    isView,
    isEdit,
    isUpdatePending,
    stateKey
  } = useAddEdit();
  const { errors } = form.formState;

  return (
    <div className="p-4 md:p-6">
      <Heading
        title={breadcrumbData[breadcrumbData.length - 1].name}
        showBack
        breadcrumbData={breadcrumbData}
        onBackClick={onBackClick}
      />

      {isStateLoading || isStateLawDataLoading ? <Loader /> : <FormProvider {...form}>
        <form>
          <div className="bg-white mt-[20px] rounded-lg px-[30px] py-[25px]">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-[30px]">
              <FormSelect
                key={stateKey}
                name={STATE}
                control={form.control}
                label="State"
                placeholder="Please enter"
                error={errors[STATE]?.message}
                isRequired={requiredFields.includes(STATE)}
                options={stateList?.data?.map((data: any) => ({
                  label: data.stateName,
                  value: data.stateId?.toString(),
                }))}
                disabled={isView || isEdit}
              />
            </div>
          </div>

          <div className="bg-white mt-[20px] rounded-lg px-[30px] py-[25px]">
            <FormSectionHeader>Law Content</FormSectionHeader>
            <div className="grid grid-cols-1 gap-[30px] w-full">
              <FormRichTextEditor 
                name={CONTENT}
                control={form.control}
                placeholder="Please enter"
                error={errors[CONTENT]?.message}
                isRequired={requiredFields.includes(CONTENT)} 
                disabled={isView}
              />
            </div>
          </div>
          <div className="flex flex-row justify-end gap-3 py-3">
            <Button
              variant="outline"
              type="button"
              onClick={onCancel}
              disabled={isAddPending || isUpdatePending}
            >
              Cancel
            </Button>
            {isView ? <></> : <><Button type="button" disabled={isAddPending || isUpdatePending} onClick={() => {
              form.handleSubmit((data) => {
                onSubmit(data, stateLawStatus.draft.value);
              })();
            }}>
              {isAddPending || isUpdatePending && <Loader variant="secondary" />}
              Draft
            </Button>
            <Button type="button" disabled={isAddPending || isUpdatePending} onClick={() => {
              form.handleSubmit((data) => {
                onSubmit(data, stateLawStatus.published.value);
              })();
            }}>
              {isAddPending || isUpdatePending && <Loader variant="secondary" />}
              Publish
            </Button>
            </>}
          </div>
        </form>
      </FormProvider>}
    </div>
  );
};

export default AddEdit;
